<template>
  <v-row class="ma-0">
    <vue-skeleton-loader
      class="mt-2"
      :width="210"
      :height="20"
    />
    <vue-skeleton-loader
      class="mt-1"
      :width="160"
      :height="40"
    />
    <vue-skeleton-loader
      class="mt-2"
      :width="220"
      :height="15"
    />
  </v-row>
</template>

<script>
import VueSkeletonLoader from 'skeleton-loader-vue'

export default {
  components: {
    VueSkeletonLoader,
  },

}
</script>

<style>

</style>
